import React from "react";
import { Box, Container, Stack } from "@mui/material";

const stats = [
  { icon: "/icons/1.svg", title: "10K+ Books", text: "Curated catalog" },
  { icon: "/icons/2.svg", title: "Fast Delivery", text: "Doorstep orders" },
  { icon: "/icons/3.svg", title: "Top Authors", text: "Trusted picks" },
  { icon: "/icons/4.svg", title: "Library Feel", text: "Clean browsing" },
];

export default function Statistics() {
  return (
    <div className={"static-frame"}>
      <Container>
        <Stack className={"info"}>
          {stats.map((item) => (
            <Stack className={"static-box"} key={item.title}>
              <Box className={"static-icon-wrap"}>
                <img src={item.icon} alt="" className={"static-pic"} />
              </Box>
              <Stack className={"static-copy"}>
                <Box className={"static-text"}>{item.title}</Box>
                <Box className={"static-subtext"}>{item.text}</Box>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Container>
    </div>
  );
}
